const archivesRouterMap = [
  // 三亚建档
  {
    name: "在线建档同意",
    path: "/archives/agree",
    component: () => import("@/pages/archives/agree"),
    meta: {
      systemCode: 'sanyaarchives'
    }
  },
  {
    name: "基本信息",
    path: "/archives/setinfostep1",
    component: () => import("@/pages/archives/setinfostep1")
  },
  {
    name: "基本信息",
    path: "/archives/setinfostep2",
    component: () => import("@/pages/archives/setinfostep2")
  },
  {
    name: "孕产信息",
    path: "/archives/setinfostep3",
    component: () => import("@/pages/archives/setinfostep3")
  },
  {
    name: "完成",
    path: "/archives/success",
    component: () => import("@/pages/archives/success")
  },
  {
    name: "我的档案",
    path: "/archives/mine",
    component: () => import("@/pages/archives/mine"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "分娩信息详情",
    path: "/archives/fenmianDetail",
    component: () => import("@/pages/archives/fenmianDetail")
  },
  {
    name: "第1次产检报告详情",
    path: "/archives/firstexamination",
    component: () => import("@/pages/archives/firstexamination")
  },
  {
    name: "第2次产检报告详情",
    path: "/archives/secondexamination",
    component: () => import("@/pages/archives/secondexamination")
  },
  {
    name: "儿童体检报告详情",
    path: "/archives/childDetail",
    component: () => import("@/pages/archives/childDetail")
  },
  // 省妇幼建档
  {
    name: "在线建档同意",
    path: "/archivesV2/agree",
    component: () => import("@/pages/archivesV2/agree")
  },
  {
    name: "告知书",
    path: "/archivesV2/notification",
    component: () => import("@/pages/archivesV2/notification")
  },
  {
    name: "基本信息",
    path: "/archivesV2/setinfostep1",
    component: () => import("@/pages/archivesV2/setinfostep1")
  },
  {
    name: "基本信息校验身份证",
    path: "/archivesV2/identitycard",
    component: () => import("@/pages/archivesV2/identitycard")
  },
  {
    name: "校验身份证失败",
    path: "/archivesV2/identitycardfail",
    component: () => import("@/pages/archivesV2/identitycardfail")
  },
  {
    name: "校验身份证失败",
    path: "/archivesV2/identitycardsuccess",
    component: () => import("@/pages/archivesV2/identitycardsuccess")
  },
  {
    name: "基本信息",
    path: "/archivesV2/setinfostep2",
    component: () => import("@/pages/archivesV2/setinfostep2")
  },
  {
    name: "孕产信息",
    path: "/archivesV2/setinfostep3",
    component: () => import("@/pages/archivesV2/setinfostep3")
  },
  {
    name: "完成",
    path: "/archivesV2/success",
    component: () => import("@/pages/archivesV2/success")
  },
  {
    name: "我的档案",
    path: "/archivesV2/mine",
    component: () => import("@/pages/archivesV2/mine")
  },
  {
    name: "婚姻状态选择",
    path: "/archivesV2/marriage",
    component: () => import("@/pages/archivesV2/marriage")
  },
  {
    name: "儿童预建档",
    path: "/archives/childAgree",
    component: () => import("@/pages/archives/childAgree"),
    meta: {
      systemCode: 'sanyachildarchives'
    }
  },
  {
    name: "身份信息",
    path: "/archives/childSetinfostep1",
    component: () => import("@/pages/archives/childSetinfostep1")
  },
  {
    name: "基本信息",
    path: "/archives/childSetinfostep2",
    component: () => import("@/pages/archives/childSetinfostep2")
  },
  {
    name: "完成",
    path: "/archives/childSuccess",
    component: () => import("@/pages/archives/childSuccess")
  },
  // 永川
  {
    name: "我的档案",
    path: "/archivesV3/mine",
    component: () => import("@/pages/archivesV3/mine"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "",
    path: "/archivesV3/healthDetail",
    component: () => import("@/pages/archivesV3/healthDetail"),
  },
  // 内蒙妇幼
  {
    name: "产检建档",
    path: "/archivesV4/select",
    component: () => import("@/pages/archivesV4/select"),
    meta: {
      systemCode: 'sanyaarchives'
    }
  },
  {
    name: "信息登记列表",
    path: "/archivesV4/list",
    component: () => import("@/pages/archivesV4/list"),
    meta: {
      systemCode: 'sanyaarchives'
    }
  },
  {
    name: "基础信息登记",
    path: "/archivesV4/baseinfo",
    component: () => import("@/pages/archivesV4/baseinfo"),
    meta: {
      systemCode: 'sanyaarchives'
    }
  },
  {
    name: "产检预建档",
    path: "/archivesV4/prereg",
    component: () => import("@/pages/archivesV4/prereg"),
    meta: {
      systemCode: 'sanyaarchives'
    }
  },
  {
    name: "在线建档同意",
    path: "/archivesV4/agree",
    component: () => import("@/pages/archivesV4/agree"),
    meta: {
      systemCode: 'sanyaarchives'
    }
  },
  {
    name: "基本信息",
    path: "/archivesV4/setinfostep1",
    component: () => import("@/pages/archivesV4/setinfostep1")
  },
  {
    name: "基本信息",
    path: "/archivesV4/setinfostep2",
    component: () => import("@/pages/archivesV4/setinfostep2")
  },
  {
    name: "孕产信息",
    path: "/archivesV4/setinfostep3",
    component: () => import("@/pages/archivesV4/setinfostep3")
  },
  {
    name: "完成",
    path: "/archivesV4/success",
    component: () => import("@/pages/archivesV4/success")
  },
  {
    name: "孕产史",
    path: "/archivesV4/setinfostep3HistoryAdd",
    component: () => import("@/pages/archivesV4/setinfostep3HistoryAdd")
  },
];

export default archivesRouterMap;
